import {makeStyles} from "@material-ui/core"

export default makeStyles(theme => ({
    container: {
        minHeight: "calc(100vh - 64px)",
        paddingBottom: theme.spacing(2),
        paddingTop: theme.spacing(2),
        backgroundColor: "#f3f3f3",
    },
    top_panel: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: theme.spacing(2),
        flexWrap: "wrap",
        backgroundColor: "#ffffff",
        paddingLeft: "20px",
        paddingRight: "25px",
        paddingTop: "12px",
        paddingBottom: "12px",
    },
    top_panel__centered: {
        justifyContent: "center",
    },
    record_name: {
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            order: 3,
            margin: "15px auto 0 auto",
            flexBasis: "100%",
            textAlign: "center",
        },
    },
    record_name__preview: {
        margin: "0 auto",
    },
    paper: {
        boxShadow: theme.shadows[3],
        color: theme.palette.text.secondary,
        padding: theme.spacing(2),
        textAlign: "center",
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
        },
    },
    info_paper: {
        marginBottom: theme.spacing(2),
    },
    loading_spinner: {
        position: "absolute",
        top: "50%",
        left: "50%",
    },
    nothing_to_review_container: {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        marginTop: theme.spacing(2),
    },
    nothing_to_review_back_button: {
        marginTop: theme.spacing(2),
    },
    pediatric_label: {
        backgroundColor: "#ffa26d",
        borderBottomLeftRadius: 15,
        borderBottomRightRadius: 15,
        color: theme.palette.primary.contrastText,
        fontWeight: 600,
        left: "50%",
        letterSpacing: 1.5,
        padding: "5px 50px",
        position: "absolute",
        top: 64,
        transform: "translateX(-50%)",
    },
    pdf: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
    },
    pdf_wrap: {
        display: "flex",
        flexDirection: "column",
    },
    pdf_item: {
        padding: "10px",
    },
    btns_wrap: {
        display: "flex",
    },
    edit_button: {
        marginRight: "10px",
    },
}));
